@use "@fukuri-admins/ui/layout" as *;

.title {
  margin: 0;
  color: text("High");
  @include typography("Jp/16_W6");
}

.successMessage {
  margin: 0;
  color: text("Green");
  @include typography("Jp/14_W3");
}

.errorMessage {
  margin: 0;
  color: text("Red");
  @include typography("Jp/14_W3");
}
